/**
 * Segmentation carried by an on-site trigger (V1: « Visite une page / visite
 * le site » and « Déclencheur personnalisé »). Evaluated by the server when the
 * page loads; a trigger without segmentation behaves as before.
 */

/** Origin of the segmentation panel opened from the trigger. */
export const TRIGGER_SEGMENTATION_ORIGIN = 'workflow_trigger_onsite_segmentation';

/** Trigger events that may carry a segmentation. */
export const SEGMENTED_TRIGGER_EVENTS = ['visit_page', 'custom_js'];

export const isSegmentableTriggerEvent = (event?: string | null): boolean => (
  SEGMENTED_TRIGGER_EVENTS.includes(event ?? '')
);

/**
 * « Durée de visite » of « Visité des URLs »: summed over the session. Already
 * reached, the scenario starts at once; otherwise the trigger waits for the
 * missing time on a matching page.
 */
export const isAwaitedVisitDuration = (propertyId?: string | null, subPropertyId?: string | null): boolean => (
  propertyId === 'visited_urls' && subPropertyId === 'time_on_page'
);

/** The saved segmentation, possibly still serialized, as a list of OR blocks. */
export const parseTriggerSegmentation = (value: unknown): unknown[] => {
  let parsed = value;
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return [];
    }
  }
  return Array.isArray(parsed) ? parsed : [];
};

/** True when the segmentation holds at least one condition. */
export const hasTriggerSegmentation = (value: unknown): boolean => (
  parseTriggerSegmentation(value).some((orBlock) => Array.isArray(orBlock)
    && orBlock.some((block) => !!block && typeof block === 'object' && Object.keys(block).length > 0))
);

/**
 * Value saved for the trigger: its segmentation, or undefined to drop one
 * saved before. The editor merges a change with the saved values and only
 * removes the keys set to undefined.
 */
export const savedTriggerSegmentation = (event: string | null | undefined, value: unknown): unknown[] | undefined => {
  const config = parseTriggerSegmentation(value);
  return isSegmentableTriggerEvent(event) && hasTriggerSegmentation(config) ? config : undefined;
};
